import { useMemo } from 'react';
import { useRouter } from 'next/router';

import { IBindingCard } from '@r1-frontend/api-domru/api-profile/v2/info/all/dto/ResponseDto';

import { IKebabItem } from '@r1-frontend/ui-react/components/KebabMenu';

import { pushDataLayer } from '~/src/features/payments-abn/helpers/pushDataLayer';

import * as ST from './styled';

export enum ECardKebabAction {
    SETUP = 'setup',
    REMOVE = 'remove',
    CONNECT = 'connect',
    DISCONNECT = 'disconnect',
}

const cardKebabItems: IKebabItem[] = [
    {
        value: ECardKebabAction.SETUP,
        label: 'Настроить автоплатёж',
    },
    {
        value: ECardKebabAction.CONNECT,
        label: 'Подключить автоплатёж',
    },
    {
        value: ECardKebabAction.DISCONNECT,
        label: 'Отключить автоплатёж',
    },
    {
        value: ECardKebabAction.REMOVE,
        label: 'Удалить карту',
    },
];

interface IProps {
    card: IBindingCard,
    onSelectMenu: (item?: IKebabItem) => void,
}

const Card = ({ card, onSelectMenu }: IProps): JSX.Element => {
    const { numberWithPaySystem, paySystem, autoPayStatus } = card;

    const router = useRouter();
    const { pathname } = router;

    const currentKebabMenu = useMemo(() => {
        if (pathname === '/lk/user/autopay') {
            return cardKebabItems.filter(item => item.value === ECardKebabAction.REMOVE);
        }

        if (autoPayStatus) {
            return cardKebabItems.filter(item => item.value !== ECardKebabAction.CONNECT);
        } else {
            return cardKebabItems.filter(item => item.value === ECardKebabAction.CONNECT || item.value === ECardKebabAction.REMOVE);
        }
    }, [autoPayStatus, pathname]);

    return (
        <ST.CardWrapper>
            <ST.CardImage>
                <img
                    src={paySystem ? `/static/images/payments-abn/pay-systems/${paySystem}.png` : '/static/images/payments-abn/stub.png'}
                    alt={paySystem ? `Логотип платёжной системы ${paySystem}` : 'Логотип банковской карты'}
                    data-test='card-image'
                />
            </ST.CardImage>
            <ST.CardNumber data-test='card-title'>{numberWithPaySystem}</ST.CardNumber>
            <ST.CardMenu
                menuItems={currentKebabMenu}
                onSelectMenu={onSelectMenu}
                onClickMenu={() => pushDataLayer('settings binding cards', 'open settings')}
                data-test='card-kebab'
            />
        </ST.CardWrapper>
    );
};

export default Card;
